import { differenceInCalendarDays } from 'date-fns';
import { createDateSafe } from '@/utils/dateUtils';
import type { VacationDpRow } from '../models/vacationDpBoard.types';
import type { DpDeadlineTone } from './vacationDpDeadline';

export interface DpPeriodCell {
    label: string;
    hint: string | null;
    tone: DpDeadlineTone;
}

export function resolveApprovedPeriodCells(
    row: VacationDpRow,
    today: Date = new Date()
): [DpPeriodCell | null, DpPeriodCell | null] {
    if (!row.approvedPeriods || row.approvedPeriods.length === 0) {
        return [null, null];
    }

    const nextPeriod = row.approvedPeriods.find((p) => p.status !== 'Completed');
    if (!nextPeriod) {
        return [null, null];
    }

    const requestId = nextPeriod.requestId;
    const periodsForRequest = row.approvedPeriods
        .filter((p) => p.requestId === requestId && p.status !== 'Completed')
        .sort((a, b) => a.startDate.localeCompare(b.startDate));

    const cells: [DpPeriodCell | null, DpPeriodCell | null] = [null, null];

    for (let i = 0; i < Math.min(2, periodsForRequest.length); i++) {
        const period = periodsForRequest[i];
        const start = createDateSafe(period.startDate);
        const end = createDateSafe(period.endDate);

        if (start && end) {
            const daysUntilStart = differenceInCalendarDays(start, today);
            let hint: string | null = null;
            let tone: DpDeadlineTone = 'none';

            if (daysUntilStart < 0) {
                hint = `${period.days}d · em férias`;
            } else if (daysUntilStart === 0) {
                hint = `${period.days}d · começa hoje`;
            } else {
                hint = `${period.days}d · inicia em ${daysUntilStart} ${daysUntilStart === 1 ? 'dia' : 'dias'}`;
            }

            cells[i] = {
                label: `${start.toLocaleDateString('pt-BR')} a ${end.toLocaleDateString('pt-BR')}`,
                hint,
                tone,
            };
        }
    }

    return cells;
}
